import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';

declare var $: any;

export interface TreeView {
  id: number;
  parent: string;
  text: string;
  value: Array<number>;
}

@Component({
    selector: 'app-action-type-tree-view',
    templateUrl: './action-type-tree-view.component.html',
    styleUrls: ['./action-type-tree-view.component.scss'],
    standalone: false
})
export class ActionTypeTreeViewComponent implements OnInit {

  public treeIcon = 'expand_more';
  public ActivityList: TreeView[];
  public isTreeInitialized: boolean;

  public ActivityTypeTree: any;

  @Output() public activityTypeSelect = new EventEmitter();
  @Output() public activityTypeDeselect = new EventEmitter();

  @ViewChild(MatMenuTrigger) activityTypeTreeMenu: MatMenuTrigger;

  constructor(
    private selectionService: SelectionGenericService,
    private filterService: FilterService) {

      this.filterService.OnFiltersCleard.subscribe(res => {
        this.initActivityTypeTree(true);
      });

  }

  ngOnInit(): void {
    this.initAcivityTypeList();
    this.triggerTreeInit();
  }

  initAcivityTypeList(): void {
    this.ActivityList = new Array<TreeView>();

    // FIRST NODE
    this.addToActivityTypeList(1, '#', 'Gestiones administrativas', [13101, 13113, 13111, 12001, 12011, 10911, 10310]);
    this.addToActivityTypeList(11, '1', 'Confirmar datos', [10310]);
    this.addToActivityTypeList(12, '1', 'Contactos', [13101, 13113]);
    this.addToActivityTypeList(121, '12', 'Para citar', [13113]); 

    // SECOND NODE
    let types = this.getContinousNumberArray(13001, 13019);
    types = types.concat(this.getContinousNumberArray(14001, 14019));
    this.addToActivityTypeList(2, '#', 'Citaciones', types);
    this.addToActivityTypeList(21, '2', 'Burofax', [13001]);
    this.addToActivityTypeList(22, '2', 'Petición cita Burofax', [13002]);
    this.addToActivityTypeList(23, '2', 'SMS', [14001]);
    this.addToActivityTypeList(24, '2', 'Petición cita SMS', [14002]);
    this.addToActivityTypeList(25, '2', 'SMS Entregado', [14011]);
    this.addToActivityTypeList(26, '2', 'SMS No Entregado', [14019]);
    this.addToActivityTypeList(27, '2', 'Acuse Burofax', this.getContinousNumberArray(13013, 13016));




    // THIRD NODE
    types = this.getContinousNumberArray(11001, 11099);
    this.addToActivityTypeList(3, '#', 'Correcciones', types);
    
    //NODE BETWEEN THE THIRD AND THE FOURTH
    this.addToActivityTypeList(31, '#', 'Respuesta Inspección',  [16210, 16211, 16214]);
    this.addToActivityTypeList(311, '31', 'Continuación de IT', [16210]);
    this.addToActivityTypeList(312, '31', 'Alta', [16211]);
    this.addToActivityTypeList(313, '31', 'Alta por Médico de Cabecera', [16214]);
    
    // FOUTH NODE
    types = this.getContinousNumberArray(30000, 30119);
    types = types.concat(this.getContinousNumberArray(30130, 30299));
    this.addToActivityTypeList(90, '#', 'Altas', [10901]);
    this.addToActivityTypeList(91, '#', 'Bajas', [10101]);
    this.addToActivityTypeList(4, '#', 'Visitas', types);

    types = this.getContinousNumberArray(30000, 30109);
    types = types.concat(this.getContinousNumberArray(30201, 30209));
    this.addToActivityTypeList(41, '4', 'Efectivas', types);

    types = this.getContinousNumberArray(30110, 30119);
    types = types.concat(this.getContinousNumberArray(30210, 30219));
    this.addToActivityTypeList(42, '4', 'Ausentes', types);
    this.addToActivityTypeList(421, '42', 'Justificadas', types);
    this.addToActivityTypeList(422, '42', 'No Justificadas', types);

    this.addToActivityTypeList(43, '4', 'Rechazadas', [30191]);

    // FIFTH NODE
    types = this.getContinousNumberArray(31000, 31119);
    types = types.concat(this.getContinousNumberArray(31130, 31299));
    this.addToActivityTypeList(5, '#', 'Contactos', types);

    types = this.getContinousNumberArray(31000, 31109);
    types = types.concat(this.getContinousNumberArray(31201, 31209));
    this.addToActivityTypeList(51, '5', 'Efectivos', types);

    types = this.getContinousNumberArray(31110, 31119);
    types = types.concat(this.getContinousNumberArray(31210, 31219));
    this.addToActivityTypeList(52, '5', 'No efectivos', types);

    this.addToActivityTypeList(53, '5', 'Para citar', [31003]);

    // SIXTH NODE
    types = this.getContinousNumberArray(30120, 30129);
    types = types.concat(this.getContinousNumberArray(31220, 31129));
    this.addToActivityTypeList(6, '#', 'Gestiones Médicas', types);

    // SEVENTH NODE
    types = this.getContinousNumberArray(37001, 37999);
    this.addToActivityTypeList(7, '#', 'Propuestas', types);

    this.addToActivityTypeList(71, '#', 'Cerrar Bajas', [10921]);

    // EIGHTH NODE
    types = this.getContinousNumberArray(36000, 36999);
    this.addToActivityTypeList(8, '#', 'Solicitudes', types);

    types = this.getContinousNumberArray(36001, 36019);
    this.addToActivityTypeList(81, '8', 'Empresa', types);
    this.addToActivityTypeList(811, '81', 'Citación Personal', [36001]);
    this.addToActivityTypeList(812, '81', 'Pago por Talón', [36002]);
    this.addToActivityTypeList(813, '81', 'Cambio de Puesto', [36003]);
    this.addToActivityTypeList(814, '81', 'Suspensión de complementos', [36006]);
    this.addToActivityTypeList(815, '81', 'Rescisión de contrato', [36004]);
    this.addToActivityTypeList(816, '81', 'Prejubilación', [36005]);

    types = this.getContinousNumberArray(36010, 36019);
    this.addToActivityTypeList(82, '8', 'Inspección', types);
    this.addToActivityTypeList(821, '82', 'Por alta', [36011]);
    this.addToActivityTypeList(822, '82', 'Por incapacidad', [36012]);
    this.addToActivityTypeList(823, '82', 'Por acumulación', [36013]);
    this.addToActivityTypeList(824, '82', 'Por valoración', [36010]);

    types = this.getContinousNumberArray(36020, 36029);
    this.addToActivityTypeList(83, '8', 'Solicitudes médicas', types);
    this.addToActivityTypeList(831, '83', 'Pruebas complementarias', [36021]);
    this.addToActivityTypeList(832, '83', 'Adelanto de pruebas', [36022]);
    this.addToActivityTypeList(833, '83', 'Especialista', [36023]);
    this.addToActivityTypeList(834, '83', 'Rehabilitación', [36024]);
    this.addToActivityTypeList(835, '83', 'Intervención quirúrgica', [36025]);
    this.addToActivityTypeList(836, '83', 'Peritación', [36054]);

    // NINTH NODE
    types = this.getContinousNumberArray(36040, 36049);
    types = types.concat(this.getContinousNumberArray(16010, 16219));
    this.addToActivityTypeList(9, '#', 'Inspección', types);

    // TENTH NODE
    this.addToActivityTypeList(1000, '#', 'Documentación', [34001, 18001]);

    // ELEVENTH NODE
    types = this.getContinousNumberArray(20100, 29001);
    this.addToActivityTypeList(1001, '#', 'Ordenes', types);

    // TWELVETH NODE
    this.addToActivityTypeList(1002, '#', 'Comentarios', [19998, 19999, 29998, 29999, 39998, 3999, 49998, 49999, 59999]);
    this.addToActivityTypeList(10021, '1002', 'Internos', [19998, 29998, 39998, 49998]);
    this.addToActivityTypeList(10022, '1002', 'Externos', [19999, 29999, 39999, 49999, 59999]);
    this.addToActivityTypeList(10023, '1002', 'Administración', [19998, 19999]);
    this.addToActivityTypeList(10024, '1002', 'Médico', [39998, 39999]);
    this.addToActivityTypeList(10025, '1002', 'Coordinación', [29998, 29999]);
    this.addToActivityTypeList(10026, '1002', 'Empresa', [49998, 49999]);
    this.addToActivityTypeList(10027, '1002', 'Mutua', [59999]);

    this.addToActivityTypeList(2000, '#', 'Solicitar Alta', [40001]);
    this.addToActivityTypeList(2001, '#', 'Mantener IT', [40002]);


  }

  private addToActivityTypeList(Id: number, Parent: string, Text: string, Value: Array<number>): void { 
    this.ActivityList.push({
      id: Id,
      parent: Parent,
      text: Text,
      value: Value
    });
    this.selectionService.ActivityList= this.ActivityList;
  }

  private getContinousNumberArray(start: number, end: number): Array<number> {
    const numberArray = new Array<number>();
    for (let i = start; i <= end; i++) {
      numberArray.push(i);
    }
    return numberArray;
  }

  triggerTreeInit(): void {
    if (!this.isTreeInitialized) {
      this.initActivityTypeTree();
    }
    this.treeIcon = 'expand_less';
    this.isTreeInitialized = true;
  }

  initActivityTypeTree(isReset = false): void {
    this.ActivityTypeTree = $('#activity-type-tree').jstree({
      core: {
        data: this.ActivityList,
        themes: { icons: false }
      },
      plugins: ['ui', 'checkbox'],
      search: {
        case_insensitive: true,
        show_only_matches: true
      }
    });

    if (isReset) {
      this.ActivityTypeTree.uncheck_all();
    } else {
      this.ActivityTypeTree.on('loaded.jstree', (e: any, data: any) => {
        // SET SELECTED NODES ON TREE INIT
        this.selectionService.ActuationSelectionModal.ActivityTypes.forEach(type => {
          this.ActivityTypeTree.jstree().select_node(type.id);
        });
        
        this.ActivityTypeTree.jstree('open_all');
      });
  
      this.ActivityTypeTree.on('select_node.jstree', (e: any, data: any) => {
        this.activityTypeSelect.emit(data.node);
      });
  
      this.ActivityTypeTree.on('deselect_node.jstree', (e: any, data: any) => {
        this.activityTypeDeselect.emit(data.node);
      });
    }
  }

  setInititalActivityType(activityTypeNode: TreeView): any {
    $('#activity-type-tree').jstree(true).select_node(activityTypeNode, false, true);
  }

  resetActivityTypeTree(): void {
    $('#activity-type-tree').jstree(true).close_all();
    this.activityTypeTreeMenu.closeMenu();
    this.treeIcon = 'expand_more';
  }

}
